import { useWhitelabel } from './useWhitelabel';
import { useLayoutEffect } from 'react';

export const useTheme = () => {
  const { whitelabelTheme, isLoadingTheme } = useWhitelabel();

  useLayoutEffect(() => {
    if (isLoadingTheme) {
      return;
    }

    const root = document.documentElement;

    Object.entries(whitelabelTheme).forEach(([key, value]) => {
      if (!value) return;

      // Just set the raw value - the CSS will wrap it with hsl()
      root.style.setProperty(`--${key}`, value);
    });
  }, [isLoadingTheme, whitelabelTheme]);

  return { isLoading: isLoadingTheme };
};
